module.exports = __webpack_public_path__ + "img/ZB6109_4.94f6ef4e.jpg";